import { Flex, Grid } from '@chakra-ui/react'
import { ReactNode, useEffect, useState } from 'react'
import { useResizeDetector } from 'react-resize-detector'
import { useLocation } from 'react-router-dom'

import { toastPortalRef, topbarRef } from '../../App'
import { Sidenav } from '../../components/Sidenav/Sidenav'
import { useAppStore } from '../../store/appStore/appStore'

interface MainLayoutProps {
  children?: ReactNode
}

export const MainLayout = ({ children }: MainLayoutProps) => (
  <Grid
    gridTemplateColumns="auto 1fr"
    gridTemplateRows="100%"
    height="100vh"
    width="100vw"
    zIndex="1"
    data-testid="main-layout"
  >
    <ToastPortal />
    <Sidenav zIndex="3" gridColumn="1" />
    {children}
  </Grid>
)

const ToastPortal = () => {
  const { pathname } = useLocation()
  const [topbarHeight, setTopbarHeight] = useState<number>(0)
  const isTopBar = useState(topbarRef.current)
  const status = useAppStore(store => store.router.componentStatus)
  const { width } = useResizeDetector({
    targetRef: topbarRef,
  })

  useEffect(() => {
    // Using setTimeout due to TopBar not being rendered yet.
    setTimeout(() => {
      if (topbarRef.current) setTopbarHeight(topbarRef.current?.clientHeight)
    }, 1)
  }, [pathname, isTopBar, width, status])

  return (
    <Flex
      ref={toastPortalRef}
      position="absolute"
      top={topbarHeight ? `${topbarHeight}px` : '0'}
      right="0"
      justifyContent="flex-end"
      height="0"
      zIndex="toast"
    />
  )
}
